























































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import PagingControl, {Page} from '@/shared/components/PagingControl.vue';
import DataTableColumn from '@/shared/components/dataTable/dataTableColumn';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';
import PageData from '@/shared/components/dataTable/pageData';
import DataTableIcon from '@/shared/components/dataTable/DataTableIcon.vue';
@Component({
	components: {
		PagingControl,
		LoadingSpinner,
		DataTableIcon
	}
})
export default class DataTable extends Vue {
	@Prop() public columns: DataTableColumn[];
	@Prop() public data: any[];
	@Prop() public total: number;
	@Prop() public loading: boolean;
	@Prop() public pagination: boolean;
	@Prop() public rowsPerPage: number;
	@Prop() public defaultSortBy: string;
	@Prop() public defaultSortDirection: string;

	public isLoading: boolean = false;
	public offset: number = 0;
	public sortBy: string;
	public sortDirection: string;

	@Watch('loading', {immediate: true})
	public loadingChangedFromParent(loading: boolean) {
		this.isLoading = loading;
	}

	@Watch('data', {immediate: true})
	public dataUpdated(data: any) {
		this.isLoading = false;
	}

	public mounted() {
		this.sortBy = this.defaultSortBy;
		this.sortDirection = this.defaultSortDirection;
	}

	public async onPageChanged(page: Page) {
		this.offset = page.start;
		await this.loadData();
	}

	public loadData() {
		this.isLoading = true;
		this.$emit('load', {
			offset: this.offset,
			sortBy: this.sortBy,
			sortDirection: this.sortDirection
		} as PageData);
	}

	public getSortClass(column: string) {
		if (column !== this.sortBy) {
			return '';
		} else {
			return this.sortDirection;
		}
	}

	public sortColumn(column: string) {
		if (column === this.sortBy) {
			if (this.sortDirection === 'desc') {
				this.sortDirection = 'asc';
			} else if (this.sortDirection === 'asc') {
				this.sortDirection = 'desc';
			}
		} else {
			this.sortDirection = 'desc';
			this.sortBy = column;
		}
		this.loadData();
	}

	public isCellClickable(row: any, clickableConfig?: boolean | ((row: any) => boolean)): boolean {
		if (typeof clickableConfig === 'function') {
			return clickableConfig(row);
		}
		return !!clickableConfig;
	}

	public cellClicked(row: any) {
		this.$emit('cellClicked', row);
	}

	public hasResults() {
		if (this.pagination) {
			return this.total > 0 && this.data && this.data.length > 0;
		} else {
			return this.data && this.data.length > 0;
		}
	}

	public requiresAlignmentFix(icon: string) {
		return icon === 'DecimalIcon';
	}

	public getDisplayValue(row: any, column: DataTableColumn): string {
		if (column.formatter) {
			return column.formatter(row);
		}
		return row[column.name];
	}
}
